// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"42c949ef","213":"5305d80e","239":"b15b18a7","450":"10447c45","455":"35f78db1","641":"ffbcd56d"}[chunkId] + ".chunk.js";
};